export const CARRIER_DETAILS_CHANGE_TRACKING = {
  carrierDetailsAdjustments: {
    source: 'carrier_details.adjustments',
    id: 12201,
  },
  carrierDetailsAssessments: {
    source: 'carrier_details.assessments',
    id: 12202,
  },
  carrierDetailsBilling: {
    source: 'carrier_details.billing',
    id: 12203,
  },
  carrierDetailsPhysicalAddress: {
    source: 'carrier_details.physical_address',
    id: 12204,
  },
  carrierDetailsCargoInsurance: {
    source: 'carrier_details.cargo_insurance',
    id: 12205,
  },
  carrierDetailsCertifications: {
    source: 'carrier_details.certifications',
    id: 12206,
  },
  carrierDetailsContacts: {
    source: 'carrier_details.contacts',
    id: 12207,
  },
  carrierDetailsCreate: {
    source: 'carrier_details.create',
    id: 12208,
  },
  carrierDetailsDetails: {
    source: 'carrier_details.carrier_details',
    id: 12209,
  },
  carrierDetailsDocuments: {
    source: 'carrier_details.documents',
    id: 12210,
  },
  carrierDetailsEquipment: {
    source: 'carrier_details.equipment',
    id: 12211,
  },
  carrierDetailsFactoringCompany: {
    source: 'carrier_details.factoring_company',
    id: 12212,
  },
  carrierDetailsFuelSurcharge: {
    source: 'carrier_details.fuel_surcharge',
    id: 12213,
  },
  carrierDetailsHighwayIntegrationData: {
    source: 'carrier_details.highway_integration_data',
    id: 12214,
  },
  carrierDetailsInternalNotes: {
    source: 'carrier_details.internal_notes',
    id: 12215,
  },
  carrierDetailsInsurance: {
    source: 'carrier_details.insurance',
    id: 12233,
  },
  carrierDetailsLiabilityInsurance: {
    source: 'carrier_details.liability_insurance',
    id: 12216,
  },
  carrierDetailsLtlPricingSetups: {
    source: 'carrier_details.ltl.pricing_setups',
    id: 12217,
  },
  carrierDetailsLtlScac: {
    source: 'carrier_details.ltl.scac',
    id: 12218,
  },
  carrierDetailsLtlSettings: {
    source: 'carrier_details.ltl_settings',
    id: 12219,
  },
  carrierDetailsMaxLtlLiability: {
    source: 'carrier_details.max_ltl_liability',
    id: 12220,
  },
  carrierDetailsMailingAddress: {
    source: 'carrier_details.mailing_address',
    id: 12234,
  },
  carrierDetailsRatings: {
    source: 'carrier_details.ratings',
    id: 12221,
  },
  carrierDetailsWorkersComp: {
    source: 'carrier_details.workers_comp',
    id: 12222,
  },
  carrierDetailsBlacklist: {
    source: 'carrier_details.header.blacklist',
    id: 12301,
  },
  carrierDetailsDelete: {
    source: 'carrier_details.header.delete',
    id: 12302,
  },
  carrierDetailsDocumentsDelete: {
    source: 'carrier_details.documents.delete',
    id: 12303,
  },
  carrierDetailsDocumentsUpload: {
    source: 'carrier_details.documents.upload',
    id: 12304,
  },
  carrierDetailsBillingDocumentsDelete: {
    source: 'carrier_details.billing.documents.delete',
    id: 12329,
  },
  carrierDetailsBillingDocumentsUpload: {
    source: 'carrier_details.billing.documents.upload',
    id: 12330,
  },
  carrierDetailsFavorite: {
    source: 'carrier_details.carrier_details.favorite',
    id: 12305,
  },
  carrierDetailsFuelSurchargeDelete: {
    source: 'carrier_details.fuel_surcharge.delete',
    id: 12306,
  },
  carrierDetailsFuelSurchargeSave: {
    source: 'carrier_details.fuel_surcharge.save',
    id: 12307,
  },
  carrierDetailsInsuranceAdd: {
    source: 'carrier_details.insurance.add',
    id: 12308,
  },
  carrierDetailsInsuranceUpdate: {
    source: 'carrier_details.insurance.update',
    id: 12309,
  },
  carrierDetailsInternalNotesAdd: {
    source: 'carrier_details.internal_notes.add',
    id: 12310,
  },
  carrierDetailsInternalNotesDelete: {
    source: 'carrier_details.internal_notes.delete',
    id: 12311,
  },
  carrierDetailsInternalNotesUpdate: {
    source: 'carrier_details.internal_notes.update',
    id: 12312,
  },
  carrierDetailsLogoUpload: {
    source: 'carrier_details.logo.upload',
    id: 12313,
  },
  carrierDetailsLtlPricingSetupsAdd: {
    source: 'carrier_details.ltl.pricing_setups.add',
    id: 12314,
  },
  carrierDetailsLtlPricingSetupsDelete: {
    source: 'carrier_details.ltl.pricing_setups.delete',
    id: 12315,
  },
  carrierDetailsLtlPricingSetupsTestLane: {
    source: 'carrier_details.ltl.pricing_setups.test_lane',
    id: 12316,
  },
  carrierDetailsLtlPricingSetupsUpdate: {
    source: 'carrier_details.ltl.pricing_setups.update',
    id: 12317,
  },
  carrierDetailsLtlScacAdd: {
    source: 'carrier_details.ltl.scac.add',
    id: 12318,
  },
  carrierDetailsLtlScacUpdate: {
    source: 'carrier_details.ltl.scac.update',
    id: 12319,
  },
  carrierDetailsPreferredLanesAdd: {
    source: 'carrier_details.preferred_lanes.add',
    id: 12320,
  },
  carrierDetailsPreferredLanesDelete: {
    source: 'carrier_details.preferred_lanes.delete',
    id: 12321,
  },
  carrierDetailsRatingsUpdateComment: {
    source: 'carrier_details.ratings.update_comment',
    id: 12322,
  },
  carrierDetailsRatingsUpdateRating: {
    source: 'carrier_details.ratings.update_rating',
    id: 12323,
  },
  carrierDetailsRequestCarrierInfo: {
    source: 'carrier_details.carrier_details.request_carrier_info',
    id: 12324,
  },
  carrierDetailsRequestReactivation: {
    source: 'carrier_details.carrier_details.request_reactivation',
    id: 12328,
  },
  carrierDetailsSaveAdjustments: {
    source: 'carrier_details.adjustments.save',
    id: 12325,
  },
  carrierDetailsUnblacklist: {
    source: 'carrier_details.header.unblacklist',
    id: 12326,
  },
  carrierDetailsUpdateInsurance: {
    source: 'carrier_details.header.update_insurance',
    id: 12327,
  },
} as const;
